/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface OfferOutputDto { 
    dsCode: string;
    dsDescription: string;
    qtMinCartValue?: number;
    nmType: number;
    qtValue: number;
    qtUpto?: number;
    isEnabled: boolean;
    isShipping: boolean;
    dtValidTill?: Date;
    cdsStores?: Array<number>;
    cdOffer: number;
    dtCreatedAt?: Date;
}